import { MULTICALL_ADDRESS, SUPPORTED_CHAIN_ID } from '../../chainConfig'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId: number]: string } = {
  [SUPPORTED_CHAIN_ID]: MULTICALL_ADDRESS
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
